/* eslint-disable complexity, max-lines*/
/* eslint-disable quotes*/

import AnalyticsHelper from "../../../shared/modules/AnalyticsHelper";
import Carousels from "../../../shared/components/Carousels";
import CartAPI from "../../../shared/modules/CartAPI";
import EventsAPI from "../../../shared/modules/EventsAPI";
import InfoContainer from "../../../shared/containers/InfoContainer";
import {Link} from "react-router-dom";
import Modal from "react-bootstrap-modal";
import NonMemberCartAPI from "../../../shared/modules/NonMemberCartAPI";
import Notification from "../../../shared/components/Notification";
import ProductDetailButtons from "../../../shared/components/ProductDetailButtons";
import ProductDetailsModalImageOrCarousel from "./ProductDetailsModalImageOrCarousel";
import PropTypes from "prop-types";
import React from "react";
import SharedPropTypes from "../../Swap/modules/SharedPropTypes";
import Star from "../../../shared/components/Star";
import SwapButton from "../../Swap/components/SwapButton";
import {connect} from "react-redux";
import {isMobile} from "../../../lib/userAgent.js";
import {sendStartedSwapEvent} from "../../../shared/modules/PreviewAndSwapEventsHelper";

class ProductDetailsModal extends React.PureComponent {

  static propTypes = {
    "addWishListCallback": PropTypes.func.isRequired,
    "customerRequests": PropTypes.object.isRequired,
    "eligibleForFineJewelry": PropTypes.bool.isRequired,
    "isLoggedOutHomepage": PropTypes.bool,
    "isPreviewAndSwapExperiment": PropTypes.bool,
    "nonMemberCartEnabled": PropTypes.bool.isRequired,
    "onCloseModal": PropTypes.func.isRequired,
    "open": PropTypes.bool.isRequired,
    "previewSwapping": PropTypes.bool,
    "product": PropTypes.object.isRequired,
    "productDescriptors": SharedPropTypes.productDescriptors.isRequired,
    "removeWishListCallback": PropTypes.func.isRequired,
    "showClearancePrice": PropTypes.bool.isRequired,
    "startSwapUrl": PropTypes.string,
    "swapHandler": PropTypes.func.isRequired,
    "updateModalProductDescriptor": PropTypes.func.isRequired
  };

  static defaultProps = {
    "customerRequests": {},
    "eligibleForFineJewelry": false,
    "isLoggedOutHomepage": false,
    "isPreviewAndSwapExperiment": false,
    "previewSwapping": false,
    "productDescriptors": [],
    "startSwapUrl": ""
  };

  constructor (props) {
    super(props);
    this.state = {
      "itemAvailability": null,
      "itemCartNotification": null,
      "timerId": null
    };
  }

  componentDidMount () {
    const {"product": {"productDescriptor": {id}}} = this.props;
    this.setItemAvailability(id);
    this.sendViewedProductEvent();
    const elements = document.querySelectorAll(".search-field-container");
    elements.forEach(element => element.classList.add("hidden"));
  }

  componentWillUpdate = (nextProps) => {
    const {"product": {"productDescriptor": {"id": newId}}} = nextProps;
    const {"product": {"productDescriptor": {"id": currentId}}} = this.props;

    if (currentId !== newId) {
      this.setItemAvailability(newId);
    }
  }

  componentWillUnmount = () => {
    const elements = document.querySelectorAll(".search-field-container");
    elements.forEach(element => element.classList.remove("hidden"));
  }

  sendViewedProductEvent = () => {
    const {product} = this.props;
    const {productDescriptor} = product;

    AnalyticsHelper.sendProductViewedEvent(productDescriptor);
    EventsAPI.trackBrowserAbandonment(productDescriptor.id);
  }

  inShipment = (currentProductDescriptorId) => {
    const {productDescriptors} = this.props;

    if (productDescriptors.length) {
      return productDescriptors.map(pd => pd.id).includes(currentProductDescriptorId);
    }

    return false;
  }

  displayExperimentButtons = () => {
    const {isPreviewAndSwapExperiment, previewSwapping, startSwapUrl} = this.props;
    return isPreviewAndSwapExperiment && previewSwapping && startSwapUrl;
  }


  isWishlisted = () => {
    const {
      customerRequests,
      "product": {"productDescriptor": {id}}
    } = this.props;

    return customerRequests[id] && customerRequests[id].statuses.includes("pending");
  }

  addToCartRequest = async (productDescriptorId, quantity) => {
    const {fetchItemCart, showClearancePrice} = this.props;
    const storeKind = showClearancePrice ? "clearance" : "retail";

    await CartAPI.addToCart(productDescriptorId, quantity, storeKind, this.handleAddToCartNotification, fetchItemCart);
    this.setState({"timerId": this.handleCloseModalAndItemAddedToCartStatus()});
  }

  handleAddToCartNotification = (notificationText) => {
    const {timerId} = this.state;
    this.setitemCartNotification(timerId, notificationText);
  };

  handleCloseModalAndItemAddedToCartStatus = () => {
    const {onCloseModal} = this.props;

    const timerId = setTimeout(() => {
      this.setState({"itemCartNotification": null});
      onCloseModal();
    }, 3000);
    return timerId;
  }

  setitemCartNotification = (timerId, notificationText) => {
    clearTimeout(timerId);
    this.setState({"itemCartNotification": notificationText});
  }

  setItemAvailability = (id) => {
    const {showClearancePrice} = this.props;
    const storeKind = showClearancePrice ? "clearance" : "retail";

    NonMemberCartAPI.getItemAvailabilityCount(id, storeKind).then((response) => {
      this.setState({"itemAvailability": response});
    });
  };

  renderStartSwapButton = () => {
    const {startSwapUrl} = this.props;

    return (
      <div className="experiment-start-swap-button">
        <Link
          className="btn btn-primary"
          onClick={sendStartedSwapEvent}
          to={startSwapUrl}
        >
          Start Swap
        </Link>
      </div>
    );
  };

  renderProductDetailsButtons = () => {
    const {itemAvailability} = this.state;
    const {
      addWishListCallback, eligibleForFineJewelry, previewSwapping, product, removeWishListCallback, showClearancePrice,
      swapHandler, productDescriptors, nonMemberCartEnabled
    } = this.props;
    const wishlisted = this.isWishlisted();

    if (previewSwapping && !this.displayExperimentButtons && isMobile()) {
      return null;
    }

    return (
      <ProductDetailButtons
        addToCartCallback={this.addToCartRequest}
        addWishListCallback={addWishListCallback}
        eligibleForFineJewelry={eligibleForFineJewelry}
        inShipment={this.inShipment(product.productDescriptor.id)}
        itemAvailability={itemAvailability}
        nonMemberCartEnabled={nonMemberCartEnabled}
        parentProps={product}
        previewSwapping={previewSwapping}
        productDescriptors={productDescriptors}
        removeWishListCallback={removeWishListCallback}
        showClearancePrice={showClearancePrice}
        swapHandler={swapHandler}
        wishlisted={wishlisted}
      />
    );
  }

  renderFullDetailsLinkForDesktop = () => {
    const {isLoggedOutHomepage, product, showClearancePrice} = this.props;
    const {"productDescriptor": {"details": {url}}} = product;
    const searchParams = showClearancePrice ? "?from_clearance=true" : "";

    return (
      <>
        {isLoggedOutHomepage &&
        <a
          className="underline"
          href={url}
          id="view-full-details"
          title="View full details"
        >
          View full details
        </a>}
        {!isLoggedOutHomepage &&
        <Link
          className="underline"
          id="view-full-details"
          to={{
            "pathname": url,
            "search": searchParams,
            "state": {
              "fromClearancePage": showClearancePrice,
              "prevPath": window.location.pathname
            }
          }}
        >
          View full details
        </Link>}
      </>
    );
  }

  renderFullDetailsLinkForMobile = () => {
    const {isLoggedOutHomepage, previewSwapping, product, showClearancePrice} = this.props;
    const {"productDescriptor": {"details": {url}}} = product;
    const searchParams = showClearancePrice ? "?from_clearance=true" : "";

    return (
      <div className="mobile-full-details">
        {isLoggedOutHomepage &&
        <a
          href={url}
          title="View full details"
        >
          View full details
        </a>}
        {!previewSwapping &&
        <Link
          className="mobile-full-details"
          id="view-full-details"
          to={{
            "pathname": url,
            "search": searchParams,
            "state": {
              "fromClearancePage": showClearancePrice,
              "prevPath": window.location.pathname
            }
          }}
        >
          View full details
        </Link>}
      </div>
    );
  }

  render () {
    const {itemAvailability, itemCartNotification} = this.state;
    const {
      addWishListCallback,
      eligibleForFineJewelry,
      isPreviewAndSwapExperiment,
      onCloseModal,
      open,
      previewSwapping,
      product,
      productDescriptors,
      removeWishListCallback,
      showClearancePrice,
      swapHandler,
      updateModalProductDescriptor
    } = this.props;
    const {productDescriptor} = product;
    const {
      "details": {
        "base_metal": baseMetal,
        designer,
        "full_size_urls": images,
        "insider_price_dollars": insiderPriceDollars,
        "is_fine": isFine,
        length,
        "metal_detail": metalDetail,
        "metal_name": metalName,
        "name": pdName,
        "other_materials_formatted": otherMaterials,
        wishlistable
      },
      id, sku
    } = productDescriptor;
    const wishlisted = this.isWishlisted();

    return (
      <>
        <Modal
          className={open
            ? "block allow-backdrop-dismiss"
            : ""}
          id="product-details-modal"
          onHide={onCloseModal}
          show={open}
        >
          <Modal.Header closeButton />
          <Modal.Body>
            {isMobile() &&
              <div className="product-details-modal-details">
                <InfoContainer
                  fromProductDetailsModal
                  handleSwatchClick={updateModalProductDescriptor}
                  itemAvailability={itemAvailability}
                  nav={false}
                  parentProps={product}
                  previewSwapping={previewSwapping}
                  showClearancePrice={showClearancePrice}
                  wishlisted={wishlisted}
                />
              </div>}
            <div className="carousels">
              {isMobile() &&
                <ProductDetailsModalImageOrCarousel
                  designer={designer}
                  images={images}
                  pdName={pdName}
                />}
              {!isMobile() &&
                <Carousels
                  designerNamer={designer}
                  images={images}
                  name={pdName}
                />}
              {wishlistable && !isMobile() && (!isFine || eligibleForFineJewelry) &&
              <Star
                addWishListCallback={addWishListCallback}
                id={id}
                price={insiderPriceDollars}
                removeWishListCallback={removeWishListCallback}
                sku={sku}
                wishlisted={wishlisted}
              />}
            </div>
            <div className="product-details-modal-details">
              {!isMobile() &&
                <div id="Info-container">
                  <InfoContainer
                    fromProductDetailsModal
                    handleSwatchClick={updateModalProductDescriptor}
                    itemAvailability={itemAvailability}
                    nav={false}
                    parentProps={product}
                    previewSwapping={previewSwapping}
                    showClearancePrice={showClearancePrice}
                    wishlisted={wishlisted}
                  />
                  <div
                    id="view-full-details-container"
                  >
                    {baseMetal && (metalName || metalDetail) &&
                      <div className="pd-metal-info">
                        <div>
                          <div className="inline bold">
                            Metal:
                          </div>
                          {" "}
                          <div className="inline">
                            {`${metalDetail ? metalDetail : metalName} over ${baseMetal}`}
                          </div>
                        </div>
                      </div>
                    }
                    {length &&
                      <div className="pd-size-info">
                        <div>
                          <div className="inline bold">
                            Size:
                          </div>
                          {" "}
                          <div className="inline">
                            {length}
                          </div>
                        </div>
                      </div>
                    }
                    {otherMaterials &&
                      <div className="pd-material-info">
                        <div>
                          <div className="inline bold">
                            Material:
                          </div>
                          {" "}
                          <div className="inline">
                            {otherMaterials}
                          </div>
                        </div>
                      </div>
                    }
                    {!previewSwapping && !this.inShipment() && this.renderFullDetailsLinkForDesktop()}
                  </div>
                </div>
              }
              {this.displayExperimentButtons() && this.renderStartSwapButton()}
              {!this.displayExperimentButtons() &&
                <div className="productDetailButton">
                  {this.renderProductDetailsButtons()}
                  {previewSwapping && isMobile() && !this.inShipment(id) &&
                    <div className="swap-actions">
                      <SwapButton
                        classes="btn-primary swap-button btn-small"
                        onSwap={swapHandler}
                        productDescriptor={productDescriptor}
                        productDescriptors={productDescriptors}
                        text="Swap"
                      />
                      <a
                        className="btn btn-secondary btn-small"
                        onClick={onCloseModal}
                      >
                        Cancel
                      </a>
                    </div>
                  }
                </div>
              }
              {isMobile() && !isPreviewAndSwapExperiment && this.renderFullDetailsLinkForMobile()}
            </div>
          </Modal.Body>
        </Modal>
        {itemCartNotification &&
          <Notification
            notificationDisplayText={itemCartNotification}
          />
        }
      </>
    );
  }
}

const mapStoreToProps = store => ({
  "customerRequests": store.customerRequests,
  "isLoggedOutHomepage": store.isLoggedOutHomepage
});

export default connect(mapStoreToProps)(ProductDetailsModal);
